import { Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from '@/components/routes/ProtectedRoute'
import { PublicRoute } from '@/components/routes/PublicRoute'
import { AppLayout } from '@/components/layout/AppLayout'
import { LoginPage } from '@/pages/LoginPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { DashboardLayout } from '@/features/orders/components/DashboardLayout'

const ActionsPage = lazy(() => import('@/features/oppgaver/components/ActionsPage'))
const QuotesPage = lazy(() => import('@/features/salg/components/QuotesPage'))
const SalesOrdersPage = lazy(() => import('@/features/salg/components/SalesOrdersPage'))
const DeliveryTimePage = lazy(() => import('@/features/leveringstid/components/DeliveryTimePage'))
const UtleveringerPage = lazy(() => import('@/features/utleveringer/components/UtleveringerPage'))
const CustomerAnalyticsPage = lazy(() => import('@/pages/CustomerAnalyticsPage'))
const InventoryAnalyticsPage = lazy(() => import('@/pages/InventoryAnalyticsPage'))
const SalesAnalyticsPage = lazy(() => import('@/pages/SalesAnalyticsPage'))
const ScrapAnalysisPage = lazy(() => import('@/features/verksted/components/ScrapAnalysisPage'))
const SettingsPage = lazy(() => import('@/features/innstillinger/components/SettingsPage'))

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="text-muted-foreground">Laster...</p>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Navigate to="/orders" replace />} />
              <Route path="/dashboard" element={<Navigate to="/orders" replace />} />

              {/* Daglig */}
              <Route path="/oppgaver" element={<ActionsPage />} />
              <Route path="/orders" element={<DashboardLayout />} />

              {/* Salg */}
              <Route path="/salg/tilbud" element={<QuotesPage />} />
              <Route path="/salg/ordrer" element={<SalesOrdersPage />} />

              {/* Verksted */}
              <Route path="/verksted/skrot" element={<ScrapAnalysisPage />} />

              {/* Analyse */}
              <Route path="/analyse/salg" element={<SalesAnalyticsPage />} />
              <Route path="/analyse/leveringstid" element={<DeliveryTimePage />} />
              <Route path="/analyse/utleveringer" element={<UtleveringerPage />} />
              <Route path="/analyse/kunder" element={<CustomerAnalyticsPage />} />
              <Route path="/analyse/lager" element={<InventoryAnalyticsPage />} />

              {/* System */}
              <Route path="/innstillinger" element={<SettingsPage />} />

              {/* Redirects fra gamle paths */}
              <Route path="/salgsordre" element={<Navigate to="/salg/ordrer" replace />} />
              <Route path="/analytics/leveringstid" element={<Navigate to="/analyse/leveringstid" replace />} />
              <Route path="/analyse/ordreflyt" element={<Navigate to="/analyse/utleveringer" replace />} />
              <Route path="/analytics/ordreflyt" element={<Navigate to="/analyse/utleveringer" replace />} />
              <Route path="/analytics/effektivitet" element={<Navigate to="/analyse/utleveringer" replace />} />
              <Route path="/settings" element={<Navigate to="/innstillinger" replace />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
